<template>
    <div class="especificaciones">
        <h2 class="title-items">{{product.modelo}}</h2>
        <h3 v-if="product.category">{{ product.category.name_es }} <span>{{ product.category.name_en }}</span></h3>
        
        <picture v-if="product.plane_image">
            <source media="(min-width: 769px)" :srcset="product.plane_image.medium">
            <source media="(min-width: 415px)" :srcset="product.plane_image.tablet_1x">
            <img :src="product.plane_image.mobile_1x" alt="">
        </picture>

        <h3 v-if="product.eslora_prfv">Eslora total <span>Length overall</span><b>{{product.eslora_prfv}} m</b></h3>
        <h3 v-if="product.manga_max">Manga <span>Beam overall</span> <b>{{product.manga_max}} m</b></h3>
        <h3 v-if="product.calado_max">Calado <span>Draft</span><b>{{product.calado_max}} m</b></h3>
        <h3 v-if="product.desplazamiento">Desplazamiento <span>Displacement</span><b>{{product.desplazamiento}} ton</b></h3>
        <h3 v-if="product.combustible">Capacidad combustible <span>Fuel capacity</span><b>{{product.combustible}} L</b></h3>
        <h3 v-if="product.agua">Capacidad agua potable <span>Water capacity</span><b>{{product.agua}} L</b></h3>
        <h3 v-if="product.propulsion">Propulsión <span>Propulsion</span> <b>{{product.propulsion}}</b></h3>
        <h3 v-if="product.grupo_elec">Grupo electrógeno <span>Generator set</span><b>{{product.grupo_elec}} kw</b></h3>
    </div>
</template>

<script>
    export default {
        name: "FichaTecnica",
        props: {
            product: Object
        }

    }
</script>

<style lang="scss" scoped>
    .especificaciones {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: .2em;
        max-width: 1000px;
        margin-right: auto;
        margin-left: auto;
    }
    .especificaciones span {
        color: #aaaaaa;
    }
    .especificaciones h3 {
        padding: 10px 0;
        border-bottom: 1px solid #aaa;
        margin: 0;
    }
    .especificaciones b {
        display: block;
        font-weight: bold;
    }
    .especificaciones .title-items {
        font-weight: bold;
        margin-bottom: 0;
    }
    @media (max-width: 769px) {
        .especificaciones {
            max-width: 90%;
        }
        .especificaciones h3 {
            font-size: 15px;
            line-height: 1.2;
        }
    }
</style>